import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AuthProvider from '@/components/AuthProvider'
import Layout from '@/components/Layout'
import Login from '@/pages/login'
import Register from '@/pages/register'
import Dashboard from '@/pages/dashboard'
import Projects from '@/pages/projects'
import ProjectDetail from '@/pages/projects/[id]'
import ProjectNew from '@/pages/projects/new'
import ProjectSchema from '@/pages/projects/[id]/schema'
import ProjectMigrations from '@/pages/projects/[id]/migrations'
import ProjectBackups from '@/pages/projects/[id]/backups'
import ProjectMonitoring from '@/pages/projects/[id]/monitoring'
import ProjectQueryBuilder from '@/pages/projects/[id]/query-builder'
import ProjectRealtime from '@/pages/projects/[id]/realtime'
import ProjectRLS from '@/pages/projects/[id]/rls'
import ProjectPITR from '@/pages/projects/[id]/pitr'
import ProjectSettings from '@/pages/projects/[id]/settings'
import ProjectReplicas from '@/pages/projects/[id]/replicas'
import Profile from '@/pages/profile'
import Developer from '@/pages/developer'
import Up from '@/pages/up'
import { useAuth } from '@/lib/auth'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  
  if (isLoading) {
    return <div>Loading...</div>
  }
  
  if (!user) {
    return <Navigate to="/login" replace />
  }
  
  return <>{children}</>
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/up" element={<Up />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/projects/new" element={<ProjectNew />} />
                  <Route path="/projects/:id" element={<ProjectDetail />} />
                  <Route path="/projects/:id/schema" element={<ProjectSchema />} />
                  <Route path="/projects/:id/migrations" element={<ProjectMigrations />} />
                  <Route path="/projects/:id/backups" element={<ProjectBackups />} />
                  <Route path="/projects/:id/monitoring" element={<ProjectMonitoring />} />
                  <Route path="/projects/:id/query-builder" element={<ProjectQueryBuilder />} />
                  <Route path="/projects/:id/realtime" element={<ProjectRealtime />} />
                  <Route path="/projects/:id/rls" element={<ProjectRLS />} />
                  <Route path="/projects/:id/pitr" element={<ProjectPITR />} />
                  <Route path="/projects/:id/replicas" element={<ProjectReplicas />} />
                  <Route path="/projects/:id/settings" element={<ProjectSettings />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/developer" element={<Developer />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

export default App